import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Detail from "./Detail.js"
import Delete from "./Delete.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"



class TitulosSeparaciones extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "pk",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create:true,
                        permission: 'imputaciones_titulosseparaciones_new',
                        component: Create,
                    },
                    {
                        edit:true,
                        permission: 'imputaciones_titulosseparaciones_detail',
                        component: Detail,
                    },
                    {
                        edit:true,
                        permission: 'imputaciones_titulosseparaciones_edit',
                        component: Edit,
                    },
                    {
                        edit:true,
                        permission: 'imputaciones_titulosseparaciones_delete',
                        component: Delete,
                    }
                ]}
                apiUrl={api.imputaciones.titulosSeparaciones.list}
                columns={this.state.columns}
                exportUrl={api.imputaciones.titulosSeparaciones.export}
                title={"Parámetros"}
                outerSort={[{"id":"nombre","desc":false}]}
            />
        );
    }
}

export default TitulosSeparaciones;



// WEBPACK FOOTER //
// ./src/views/Imputaciones/TitulosSeparaciones/TitulosSeparaciones.js